import { ButtonVariants, FormControlSizes, ToggleGroup } from '@talos/kyoko';
import type { BalancesBlotterShowBy } from '../../../Blotters/BalancesV2/types';

// This component can be used in several places so put it in the shared folder

interface ShowByButtonsProps {
  showBy: BalancesBlotterShowBy;
  onClick: (newShowBy: BalancesBlotterShowBy) => void;
  size?: FormControlSizes;
}

export const ShowByButtons = ({ showBy, onClick, size = FormControlSizes.Default }: ShowByButtonsProps) => {
  return (
    <ToggleGroup
      options={[
        { value: 'counterparty', displayName: 'By Counterparty', testId: 'by-counterparty-button' },
        { value: 'asset', displayName: 'By Instrument', testId: 'by-asset-button' },
      ]}
      value={showBy}
      onChange={onClick}
      size={size}
      boxProps={{ flex: '0 0 auto', w: 'auto' }}
      data-testid="show-by-buttons"
      defaultSelectedVariant={ButtonVariants.Priority}
    />
  );
};
